import { Api } from 'utils';

class PublicService {
	
	static invitations = {
		get: async (params?: any) => Api.createResponse('public/invitations',params),
		save: async (params?: any) => Api.createResponse('public/invitations/save',params),
		finishRegister: async (params?: any) => Api.createResponse('public/invitations/finish-register',params),
	}

}

export default PublicService;